import { useEffect } from 'react';
import { ITimer } from '../interface/timer';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';
import { useFetchUserParameters } from './useFetchUserParameters';
import { useFetchTransactionTypes } from './useFetchTransactionTypes';
import { ITranslations } from '../interface';
import { getTranslationFromTranslatableEntity } from '../constants/matter';
import { areStringsEqual } from '../constants/utilityFunctions';
import { SystemConstants } from '../constants/constants';
import { showToast } from '../components/utils/toast';

export const useTimerInitialization = (
  timer: ITimer | null,
  updateTimer: (timer: ITimer | null) => void,
) => {
  const { t } = useTranslation();
  const { getAppLanguageCode } = useLanguage();

  const { data: parametersDetails } = useFetchUserParameters({
    parametersToGet: 'transaction',
  });

  const isTransactionTypeInUse =
    parametersDetails?.parameters?.transactionParameters?.transactionTypeInUse ?? false;

  const { data: defaultTransactionType } = useFetchTransactionTypes({
    defaultTransactionTypeId:
      !isTransactionTypeInUse || (timer?.isTransactionTypeManuallyAdded ?? false)
        ? undefined
        : (timer?.matter?.defaultTransactionTypeId ??
          parametersDetails?.parameters?.transactionParameters?.defaultTransactionTypeId),
    fields: ['unitPrice', 'standardPrice', 'units', 'translations', 'transactionTypeUsage'],
  });

  const getTranslatedSubject = (translations: ITranslations[]) => {
    return getTranslationFromTranslatableEntity(
      translations,
      timer?.matter?.language ?? getAppLanguageCode(),
    );
  };

  useEffect(() => {
    if (!defaultTransactionType) return;

    if (
      !timer?.isTransactionTypeManuallyAdded &&
      !areStringsEqual(
        defaultTransactionType?.unit?.id ?? defaultTransactionType?.unitId,
        SystemConstants.UNIT_HOUR,
      )
    ) {
      showToast('info', t('transaction:defaultTransactionTypeIsNotOfUnitHour'));
      return;
    }

    updateTimer({
      ...timer,
      transactionTypeId: defaultTransactionType?.id,
      transactionType: defaultTransactionType,
      ...(!timer?.isSubjectManuallyAdded && {
        subject: getTranslatedSubject(defaultTransactionType?.translations || []),
      }),
    } as ITimer);
  }, [defaultTransactionType]);
};
